import React from 'react';
import PropTypes from 'prop-types';
var DepositStatusComponent = function DepositStatusComponent(props, context) {
  var txnState = props.txnState;
  var status = {
    '1': {
      status: 'pending',
      firstLine: context.t('Your deposit is being processed.'),
      secondLine: context.t('Your account balance will be updated soon.')
    },
    '2': {
      status: 'successful',
      firstLine: context.t('Your deposit was successfull.'),
      secondLine: context.t('Your account balance will be updated soon.')
    },
    '3': {
      status: 'failed',
      firstLine: context.t('There was a problem with your deposit.'),
      secondLine: context.t('Please try again or contact an administrator.')
    }
  };
  return React.createElement('div', null, React.createElement('div', null, status[txnState].firstLine), React.createElement('div', null, status[txnState].secondLine));
};
DepositStatusComponent.propTypes = {
  txnState: PropTypes.string.isRequired
};
DepositStatusComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default DepositStatusComponent;